import axios from 'axios'
import laroute from '~/laroute'
import store from '~/store'

// state
export const state = {
  currentSelection: null
}

// getters
export const getters = {
  currentSelection: state => state.currentSelection
}

// mutations
export const mutations = {
  CURRENT (state, data) {
    state.currentSelection = data
  }
}

// actions
export const actions = {
  async setCurrentSelection ({ commit }, id) {
    await axios.get(laroute.route('get_province', { companyAbbr: store.getters['auth/company'], id: id }))
      .then((res) => {
        commit('CURRENT', res.data)
      })
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/province.js